var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKbvV16TipsModalFootballRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 15.75 15.75",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.125 -1.125)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f62e39",
    d: "M14.569,3.432a7.875,7.875,0,1,0,0,11.137A7.875,7.875,0,0,0,14.569,3.432ZM14.422,4.86a6.788,6.788,0,0,1,1.4,3.871L13.649,7.1ZM10.97,2.465,9.054,3.888,7.049,2.46a6.83,6.83,0,0,1,3.921.006ZM4.432,7.1,2.18,8.748A6.789,6.789,0,0,1,3.594,4.839Zm-1,5.839h2.6l.821,2.542a6.855,6.855,0,0,1-3.426-2.542Zm4.62,2.821L6.8,11.888H2.817A6.769,6.769,0,0,1,2.248,10L5.693,7.477,4.392,3.97a6.856,6.856,0,0,1,1.5-1.046L9.067,5.187,12.11,2.926a6.855,6.855,0,0,1,1.506,1.052l-1.209,3.5,3.345,2.517a6.768,6.768,0,0,1-.569,1.893H11.347l-1.38,3.869a6.828,6.828,0,0,1-1.919,0Zm3.137-.292.9-2.529h2.485a6.857,6.857,0,0,1-3.387,2.529Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f62e39",
    d: "M17.713,13.286l-2.919-2.121-2.919,2.121,1.115,3.431H16.6Zm-1.878,2.381H13.753l-.643-1.98,1.685-1.224,1.685,1.224Z",
    transform: "translate(-5.734 -5.355)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbvV16TipsModalFootballRed);
export default __webpack_public_path__ + "static/media/kbv-v16-tips-modal-football-red.697bf78c8f4f791b1b75e903ee65b35f.svg";
export { ForwardRef as ReactComponent };